import baseV3Service from './base/baseV3Service.js';
import serverSideEventService from './base/serverSideEventService.js';
import analyticsV2BaseService from './base/analyticsV2BaseService.js';

const getOnlineEngagement = (config) => {
    return analyticsV2BaseService.get(`engagement`, config);
};
const getLeasingVelocity = (config) => {
    return analyticsV2BaseService.get(`engagement/leasing-velocity`, config);
};
const getApplicationRate = (config) => {
    return analyticsV2BaseService.get(`engagement/application-rate`, config);
};
const getTrafficSources = (config) => {
    return analyticsV2BaseService.get(`traffic-sources`, config);
};
const getMostToursData = (option, config) => {
    return analyticsV2BaseService.get(`tours/${option}`, config);
};
const getMostScheduled = (option, config) => {
    return analyticsV2BaseService.get(`tours/${option}`, config);
};
const getMostViewed = (option, config) => {
    return analyticsV2BaseService.get(`views/${option}`, config);
};
const getCaptureDetails = (config) => {
    return analyticsV2BaseService.get(`scans`, config);
};
const getCaptureSummary = (config) => {
    return analyticsV2BaseService.get(`scans/summary`, config);
};
const getSgtDetails = (config) => {
    return analyticsV2BaseService.get(`sgt`, config);
};
const getCommunititesComparisonData = (option, config) => {
    return analyticsV2BaseService.get(`${option}`, config);
};
const getCommunitiesSummary = (config) => {
    return analyticsV2BaseService.get(`summary`, config);
};
const getDayWiseSpacesViews = (config) => {
    return baseV3Service.get(`analytics/daywise-spaces-views`, config);
};
const getViewedSpaces = (config) => {
    return baseV3Service.get("analytics/viewed-spaces", config);
};
const sendAnalyticsEvent = (analyticsEventPayload) => {
    const { anonymousId, sessionId } = analyticsEventPayload;
    const updatedAnalyticsEventPayload = Object.assign(Object.assign({}, analyticsEventPayload), { anonymousId: anonymousId === null || anonymousId === void 0 ? void 0 : anonymousId.split("-").join(""), sessionId: sessionId === null || sessionId === void 0 ? void 0 : sessionId.split("-").join("") });
    fetch(process.env.PEEK_APP_ANALYTICS_API_URL, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedAnalyticsEventPayload),
        keepalive: true,
    }).catch((error) => {
        console.error("Error sending analytics event", error);
    });
};
const downloadAnalyticsReports = (payload, onFileStatusChange) => {
    return serverSideEventService.post("analytics/csv", payload, (data) => {
        const json = data.replace("data:", "").replace("\n", "").replace("data: done", "").trim();
        if (!json)
            return;
        const parsedData = JSON.parse(json);
        onFileStatusChange(parsedData.fileName, parsedData.status, parsedData.content);
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};

export { downloadAnalyticsReports, getApplicationRate, getCaptureDetails, getCaptureSummary, getCommunitiesSummary, getCommunititesComparisonData, getDayWiseSpacesViews, getLeasingVelocity, getMostScheduled, getMostToursData, getMostViewed, getOnlineEngagement, getSgtDetails, getTrafficSources, getViewedSpaces, sendAnalyticsEvent };
